<template>
  <div class="pagelabel">
    <el-pagination
      background
      :current-page.sync="_currPage"
      :page-size.sync="_pageSize"
      :page-sizes="pageSizes"
      :total="total"
      :popper-class="popperClass"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    popperClass: {
      type: String,
      default: ''
    },
    total: {
      required: true,
      type: Number,
    },
    currPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50];
      },
    },
  },
  computed: {
    _currPage: {
      get() {
        return this.currPage;
      },
      set(val) {
        this.$emit("update:currPage", val);
      },
    },
    _pageSize: {
      get() {
        return this.pageSize;
      },
      set(val) {
        this.$emit("update:pageSize", val);
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pagination");
      this.$emit("pageSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("pagination");
      this.$emit("pageNumChange", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagelabel {
  text-align: right;
  margin-top: 26px;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: $primaryColor !important;
}

::v-deep .el-pagination.is-background .el-pager li:not(.active):hover {
  color: $primaryColor !important;
}
</style>
